export default __webpack_public_path__ + "img/ErrorBoundary.515a6a6839d30b9f487d0001701ecd33.png";